import { render } from "./InspectorDashboard.vue?vue&type=template&id=52e69322&scoped=true"
import script from "./InspectorDashboard.vue?vue&type=script&lang=js"
export * from "./InspectorDashboard.vue?vue&type=script&lang=js"

import "./InspectorDashboard.vue?vue&type=style&index=0&id=52e69322&scoped=true&lang=css"
import "./InspectorDashboard.vue?vue&type=style&index=1&id=52e69322&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52e69322"]])

export default __exports__